export enum Language {
  NL = 'nl',
  EN = 'en',
  FR = 'fr',
  DE = 'de',
}
